import { render, staticRenderFns } from "./ModalPage.vue?vue&type=template&id=037ccdac&scoped=true"
import script from "./ModalPage.vue?vue&type=script&lang=ts"
export * from "./ModalPage.vue?vue&type=script&lang=ts"
import style0 from "./ModalPage.vue?vue&type=style&index=0&id=037ccdac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ccdac",
  null
  
)

export default component.exports